<template>
  <div>
    <Head title="Mail Templates" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Mail Settings</li>
      </ol>
    </nav>
    <h1>Mail Templates</h1>

    <div class="row">
      <div class="col-md-6">
        <div class="content-box">
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Code</th>
                <th>Group</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in customer_templates.data" :key="template.id">
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`">
                    {{ template.name }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`" tabindex="-1">
                    {{ template.code }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`" tabindex="-1">
                    {{ template.group }}
                  </Link>
                </td>
              </tr>
              <tr v-if="customer_templates.length === 0">
                <td colspan="2">No templates found.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination class="mt-3" :links="customer_templates.links" />
      </div>

      <div class="col-md-6">
        <div class="content-box">
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Code</th>
                <th>Group</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in agency_templates.data" :key="template.id">
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`">
                    {{ template.name }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`" tabindex="-1">
                    {{ template.code }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`" tabindex="-1">
                    {{ template.group }}
                  </Link>
                </td>
              </tr>
              <tr v-if="agency_templates.length === 0">
                <td colspan="2">No templates found.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination class="mt-3" :links="agency_templates.links" />
      </div>

      <div class="col-md-6 mt-3">
        <div class="content-box">
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Code</th>
                <th>Group</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in operator_templates.data" :key="template.id">
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`">
                    {{ template.name }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`" tabindex="-1">
                    {{ template.code }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/settings/mail/templates/${template.id}/edit`" tabindex="-1">
                    {{ template.group }}
                  </Link>
                </td>
              </tr>
              <tr v-if="operator_templates.length === 0">
                <td colspan="2">No templates found.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination class="mt-3" :links="operator_templates.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    customer_templates: Object,
    agency_templates: Object,
    operator_templates: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
